module.exports = __webpack_public_path__ + "img/right_md_3.2b74a794.jpg";